import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w-full flex flex-col items-center justify-center" }
const _hoisted_2 = { class: "w-24 h-24 bg-primarylighthover rounded-full flex justify-center items-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "pt-4 pb-8 text-center" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "font-medium text-lg" }, "Override selected parking spot"),
  /*#__PURE__*/_createElementVNode("p", { class: "text-sm" }, "Are you sure you want to override selected parking spot?")
], -1)
const _hoisted_4 = { class: "flex px-6 gap-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_modal_component = _resolveComponent("modal-component")!

  return (_openBlock(), _createBlock(_component_modal_component, {
    "is-displayed": _ctx.isOverrideModalOpened,
    "custom-modal-size": "w-3/12",
    title: "Override parking spot",
    onToggleModal: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('toggle-modal')))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_font_awesome_icon, {
              icon: ['fas', 'triangle-exclamation'],
              class: "text-4xl text-primary"
            })
          ]),
          _hoisted_3
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_the_button, {
            "full-width": true,
            "button-type": "oulineButton",
            text: "Cancel",
            onExecuteMethod: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('toggle-modal')))
          }),
          _createVNode(_component_the_button, {
            "full-width": true,
            "button-type": "primaryButton",
            text: "Override",
            onExecuteMethod: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('override-action')))
          })
        ])
      ])
    ]),
    _: 1
  }, 8, ["is-displayed"]))
}